import { idsToColors } from '../../../utils/colour/colours';

export function createSubgroupColorGenerator(
  subgroups: ReadonlyArray<Readonly<{ _id: string | null | undefined }>>,
) {
  return (subgroupId: string) => {
    const colorMap = idsToColors(
      filterResults(subgroups?.map((group) => group._id)),
    );
    return colorMap[subgroupId];
  };
}

function filterResults<T>(arr: Array<T | null | undefined>): T[] {
  return arr.filter((item: T | undefined | null): item is T => Boolean(item));
}
